module.exports = __webpack_public_path__ + "static/media/municipalidad.9ac6ee38.jpg";